import SelectedItemCheckbox from "@/dsComponents/SelectedItemCheckbox";

const ModalSelectedList = ({ items, title = 'Selected', valueKey = 'name', subValueKey }) => {
	return (
		<>
			<div className="modal-selected-items--text modal-selected-items--border--bottom">
				{title}
			</div>
			<div className='modal-selected-items--table'>
				{items
					.map((item, index) => {
						return (
							<div key={index} className="modal-selected-items--row modal-selected-items--border--bottom">
								<SelectedItemCheckbox data-testid="role-checkbox" />
								<div className="modal-selected-items--row--text">
									<div className="modal-selected-items--row--text--title">
										{item?.[valueKey]}
									</div>
									{item?.[subValueKey] &&
										<div className="modal-selected-items--row--text--subtitle">
											{item?.[subValueKey]}
										</div>
									}
								</div>
							</div>
						);
					})}
			</div>
		</>
	)
};

export default ModalSelectedList;
